import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './_services/auth.service';
import { User } from './_models/user';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterEvent } from '@angular/router';
import { NotifyService } from 'src/app/_services/notify.service';
import { Subscription } from 'rxjs';
import { Notify } from './_models/notify';
import { NotificationService } from '@progress/kendo-angular-notification';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { CurrencyService } from './_services/currency.service';
import { Currency } from './_models/currency';

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styles: [
      `
         .notification-online {
            padding: 10px 5px;
            color: green;
         }
         .notification-offline {
            padding: 10px 5px;
            color: red;
         }
      `,
   ],
})
export class AppComponent implements OnInit, OnDestroy {
   loadingApp = true;
   jwtHelper = new JwtHelperService();
   isConnected = true;
   isLoggedin = false;
   private subscription!: Subscription;
   @ViewChild('appendTo', { read: ViewContainerRef })
   public appendTo!: ViewContainerRef;
   constructor(
      @Inject(LOCALE_ID) public localeId: string,
      public intlService: IntlService,
      private notifyService: NotifyService,
      private authService: AuthService,
      private notification: NotificationService,
      private router: Router,
      private currecyService: CurrencyService
   ) {
      router.events.subscribe((routerEvent: RouterEvent) => {
         this.checkRouterEvent(routerEvent);
      });
   }
   ngOnInit(): void {
      this.authService.loggedInNotify.subscribe((loggedIn) => {
         if (loggedIn) {
            this.setCurrency();
            this.isLoggedin = loggedIn;
         }
      });
      this.authService.loggedOutNotify.subscribe((loggedOut) => {
         if (loggedOut) {
            this.authService.isLoggedIn = false;
            this.isLoggedin = false;
            this.router.navigate(['/login']);
         }
      });

      const token = localStorage.getItem('token');
      localStorage.setItem('isReset', 'false');
      const user: User = JSON.parse(localStorage.getItem('user'));
      if (token) {
         this.authService.decodedToken = this.jwtHelper.decodeToken(token);
         this.authService.checkExpiration();
         this.isLoggedin = true;
         this.authService.isLoggedIn = true;

         if (user) {
            this.authService.currentUser = user;
         }
      }
      if (this.authService.isLoggedIn) {
         this.setCurrency();
      }

      //Notification code
      this.subscription = this.notifyService.notifySubject.subscribe((_notify: Notify) => {
         if (_notify.type === 'success') {
            this.notification.show({
               appendTo: this.appendTo,
               content: _notify.content,
               cssClass: 'ams-notification',
               hideAfter: 3500,
               position: { horizontal: 'center', vertical: 'bottom' },
               animation: { type: 'fade', duration: 400 },
               type: { style: 'success', icon: true },
            });
         } else if (_notify.type === 'error') {
            this.notification.show({
               appendTo: this.appendTo,
               content: _notify.content,
               cssClass: 'ams-notification',
               position: { horizontal: 'center', vertical: 'top' },
               animation: { type: 'fade', duration: 400 },
               type: { style: 'error', icon: true },
               closable: true,
            });
         } else if (_notify.type === 'warning') {
            this.notification.show({
               appendTo: this.appendTo,
               content: _notify.content,
               cssClass: 'ams-notification',
               hideAfter: 2200,
               position: { horizontal: 'center', vertical: 'top' },
               animation: { type: 'fade', duration: 400 },
               type: { style: 'warning', icon: true },
               closable: true,
            });
         } else if (_notify.type === 'info') {
            this.notification.show({
               appendTo: this.appendTo,
               content: _notify.content,
               cssClass: 'ams-notification',
               hideAfter: 3500,
               position: { horizontal: 'center', vertical: 'bottom' },
               animation: { type: 'fade', duration: 400 },
               type: { style: 'info', icon: true },
            });
         }
      });
   }
   setCurrency() {
      this.currecyService.getCompanyCurrency().subscribe({
         next: (_currency: Currency) => {
            if (_currency.id === 'ZAR') {
               (<CldrIntlService>this.intlService).localeId = 'en-ZA';
            } else if (_currency.id === 'GBP') {
               (<CldrIntlService>this.intlService).localeId = 'en-GB';
            } else if (_currency.id === 'USD') {
               (<CldrIntlService>this.intlService).localeId = 'en';
            } else if (_currency.id === 'MUR') {
               (<CldrIntlService>this.intlService).localeId = 'en-MU';
            }
         },
         error: (error) => {},
      });
   }
   checkRouterEvent(routerEvent: RouterEvent): void {
      if (routerEvent instanceof NavigationStart) {
         this.loadingApp = true;
      }

      if (routerEvent instanceof NavigationEnd || routerEvent instanceof NavigationCancel || routerEvent instanceof NavigationError) {
         this.loadingApp = false;
      }
   }
   ngOnDestroy() {
      this.subscription.unsubscribe();
   }
   loggedIn() {
      return this.isLoggedin;
   }
}
